import { RootState } from '@/App/store';

export const selectAppConfigInitialized = (state: RootState) => state.config.initialized;
